import { Coords, OrderStopType, PaymentMethod, Product, VehicleType } from "@app/modules/create-order/entities/create-order.entities";

export enum OrdersType {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

export enum ETAType {
  "USER" = "USER",
  "STOP" = "STOP",
  "STORE" = "STORE",
}

export interface ActiveOrderQueryParams {
  pickingPointId: number;
  inputSearch?: string;
  status?: number[];
  orderBy?: OrderBy;
}

export interface ArchivedOrderQueryParams extends ActiveOrderQueryParams {
  pageNumber?: number;
}

export interface SearchOrderQueryParams extends ArchivedOrderQueryParams {
  ordersType: OrdersType;
}

export interface OrderBy {
  name: string;
  type: "ASC" | "DESC";
}

export interface OrderColumn {
  id: string;
  optional: boolean;
  orderType?: "ACTIVE" | "ARCHIVED";
}

export interface OrdersState {
  ui: UiOrders;
  selectedOrder: DetailOrder;
  activeOrdersList: ListOrder[];
  archivedOrdersList: ListOrder[];
  ordersType: OrdersType;
  searchInput?: string;
}

export interface StatusFilterOption {
  status: string;
  status_ids: number[];
}

export interface UiOrders {
  loaderBtnCancel?: boolean;
  loadingOrderDetail?: boolean;
  loadingOrderList?: boolean;
  loadingExcelExport?: boolean;
  isModalCancelShow?: boolean;
  loaderBtn?: boolean;
  isLoading?: boolean;
  hasData?: boolean;
  isForm?: boolean;
  deleteSuccess?: boolean;
  lastArchivedOrdersPage?: boolean;
  columns: string[];
  openColumnSettingsDialog: boolean;
  openExcelDialog: boolean;
  orderBy?: OrderBy;
}

export enum TransportMediaType {
  neither = "neither",
  bicycle = "bicycle",
  motorbike = "motorbike",
  car = "car",
  generic = "generic",
}

export interface ListOrder {
  id: string | number;
  created_at: string;
  deadline_at: string;
  eta: string;
  handshake_code: string;
  tracking_code: string;
  order_destination_first_name: string;
  order_external_id: number;
  order_id: string;
  order_rappi_id: number;
  order_status_id: number;
  order_total_value: number;
  order_type: number;
  pickingpoint_name: string;
  placed_at: string;
  version: number | null;
}

export interface OrderPagination {
  perPage: number;
  currentPage: number;
  from: number;
  to: number;
  lastPage?: number;
}

export interface OrderUpdate {
  id: number;
  order_id: number;
  rappi_order_id: number;
  order_status_id: number;
  core_status: string;
  updated_at: string;
}
export interface OrderModification {
  created_at: string;
  id: number;
  order_id: number;
  type: string;
  rappi_order_id: number;
}

export interface DetailActionPoint {
  address: string;
  check_in_required: boolean;
  city: string;
  comments?: string;
  contact_email: string;
  contact_name: string;
  contact_phone: string;
  description: string;
  executed: boolean;
  external_picking_point_id: string | number | null;
  id: string;
  index: number;
  instructions: string;
  lat: number;
  lng: number;
  picking_point_id: number | null;
  products: Product[];
  return_allowed: boolean;
  zip_code: any;
  picking_point_name: string;
  stop_type: OrderStopType;
}

export interface ETA {
  time: number;
  type: ETAType;
}

export interface DetailOrder {
  action_points: DetailActionPoint[];
  arrival_time: string;
  cancelation_reason: string;
  cancellation_username: string | null;
  cancelled_at: string;
  cargo_order_id: string;
  client: OrderClient;
  courier: Courier;
  created_at: string;
  deliver_at: string;
  eta: ETA | null;
  external_order_id: string;
  final_delivery_comments?: string;
  final_delivery_lat?: number;
  final_delivery_lng?: number;
  final_delivery_point_image?: string;
  handoff_code: string | null;
  handshake_code: string | null;
  order_modification: OrderModification[];
  order_status_id: number;
  order_update: OrderUpdate[];
  origin: string;
  payment_method: PaymentMethod;
  price: any;
  rappi_order_id: number;
  requires_handshake: boolean;
  retailer_id: string;
  state: string;
  total_value: number;
  tracking_code: string;
  vehicle_type: VehicleType;
  version: number | null;
  was_cancelled_by_integration: boolean;
  partner_cancelation_reason: string | null;
  was_processed_by_agent: boolean;
}

export interface OrderClient {
  address: string;
  email: string;
  first_name: string;
  last_name: string;
  lat: number;
  lng: number;
  phone: string;
}

export interface StoreKeeperProps {
  coords?: Coords;
  transport_media_type?: TransportMediaType;
}

export interface Courier {
  first_name: string;
  last_name: string;
  id: number;
  phone: string;
  lat: number;
  lng: number;
  transport_media_type: TransportMediaType;
}
